function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Start = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Shared = require("../Shared");
var _MegaphoneWithLegs = require("../../../../images/MegaphoneWithLegs");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _styles = require("./styles");
var _styles2 = require("../../../../styles");
var _components = require("../../../../components");
var _reactNative = require("react-native-web");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Start = exports.Start = (0, _react.memo)(function (_ref) {
  var navigation = _ref.navigation;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useSharedStyles = (0, _Shared.useSharedStyles)(),
    sharedStyles = _useSharedStyles.sharedStyles,
    imageWidth = _useSharedStyles.imageWidth;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var _backgroundWidth = imageWidth * 1.4;
  var _imageWidth = imageWidth * 1.4;
  if (bp.is([bp.tablet, bp.desktop])) {
    _backgroundWidth = imageWidth;
    _imageWidth = imageWidth;
  }
  var _backgroundHeight = _backgroundWidth * _Shared.IllustrationBackgroundHeightRatio;
  var _imageHeight = _imageWidth * _MegaphoneWithLegs.MegaphoneWithLegsHeightRatio;
  var _onPress = function _onPress() {
    return navigation.navigate('AboutYou');
  };
  return (0, _jsxRuntime.jsx)(_Shared.Layout, {
    testID: "Start",
    showShapes: true,
    children: (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.container,
      children: [(0, _jsxRuntime.jsx)(_components.Text, {
        containerStyle: [sharedStyles.textContainer, styles.text],
        children: t('onboardingStart:title')
      }), (0, _jsxRuntime.jsx)(_Shared.IllustrationBackground, {
        backgroundStyle: {
          width: _backgroundWidth,
          height: _backgroundHeight
        },
        style: {
          minWidth: _backgroundWidth,
          minHeight: _backgroundHeight
        },
        children: (0, _jsxRuntime.jsx)(_MegaphoneWithLegs.MegaphoneWithLegs, {
          style: {
            transform: [{
              translateY: (_backgroundHeight - _imageHeight) / 2
            }],
            width: _imageWidth,
            height: _imageHeight
          }
        })
      }), (0, _jsxRuntime.jsx)(_Shared.NextButton, {
        onPress: _onPress,
        isWidthAuto: true
      })]
    })
  });
});